module.exports = __webpack_public_path__ + "static/joaco-compromiso-dc279752987d88866c45ba3b0e7726ac.svg";